import { useParams } from 'react-router';
import { Fieldset } from '../../../../../../shared/ui/form/fieldset/FieldsetContainer';
import { Input } from '../../../../../../shared/ui/form/input/Input';
import { useZeroStageVm } from './useZeroStage.vm';
import { Button, Grid, Typography } from '@mui/material';

export const ZeroStage = () => {
  const { formik, handleSave } = useZeroStageVm();
  const params = useParams();

  const isCushing = params && params?.type?.includes('cushing') && params?.version?.includes('v2');

  return (
    <Fieldset legend={'Tytuł i opis przypadku'}>
      <Grid container>
        <Grid item xs={12} mt={1}>
          <Input
            InputLabelProps={{ shrink: true }}
            name={'title'}
            type={'text'}
            onChange={formik.handleChange}
            required={true}
            onBlur={formik.handleBlur}
            error={Boolean(formik.errors.title)}
            value={formik.values.title}
            label={'Tytuł przypadku'}
          />
        </Grid>
        <Grid item xs={12} mt={2}>
          <Input
            InputLabelProps={{ shrink: true }}
            name={'description'}
            type={'textarea'}
            multiline={true}
            rows={3}
            onChange={formik.handleChange}
            required={true}
            onBlur={formik.handleBlur}
            error={Boolean(formik.errors.description)}
            value={formik.values.description}
            label={'Opis przypadku'}
          />
        </Grid>
        <Grid item xs={12} mt={1}>
          <Typography variant="caption" color={'#ED6C02'}>
            Dodaj kilkuzdaniowe streszczenie opisu przypadku medycznego.
          </Typography>
        </Grid>
        {isCushing && (
          <Grid item xs={12} display={'flex'} justifyContent={'flex-end'} mt={2}>
            <Typography variant="caption" color={'rgba(0,0,0,0.6)'}>
              PL-IST-0068
            </Typography>
          </Grid>
        )}
        <Grid item xs={12} mt={4}>
          <Button fullWidth={true} onClick={handleSave} size={'large'} color={'primary'} variant={'contained'}>
            Zapisz i przejdź dalej
          </Button>
        </Grid>
      </Grid>
    </Fieldset>
  );
};
